// SSR-safe: Check if document exists (browser only)
const bodyDataValues =
  typeof document !== "undefined" ? document.querySelector("body")?.dataset : undefined;

export const DEFAULT_SOURCE = "WEB";
export const DEFAULT_CONNECTION_FROM = "Upgrade-ws";
export const REST_CONNECTION_FROM = "rest";
export const CONNECTION_MANAGER_ENV = (() => {
  const envMapping: { [key: string]: string } = {
    uat: "UAT",
    iuat: "iUAT",
    production: "PRODUCTION",
  };

  const env = bodyDataValues?.connectionmanagerenv?.toLowerCase();
  return envMapping[env as string] || "PRODUCTION";
})();
export const WEB_SOURCE_IDENTIFIER = "3IN1-Web";
export const WEB_SOURCE_IDENTIFIER_GL = "2";

export const OPERATION_IDS = {
  mflInsert: "mfiinsert",
  deleteFromCart: "deletefromcart",
  cmsCartProducts: "cmscartproducts",
  readFromCart: "readfromcart",
  getACallBack: "callback",
  doacqValidate: "doacqvalidate",
  fdFetchBrokerId: "fdfetchbrokerid",
  nclInsert: "newcarloaninsert",
  fdDetails: "fdDetails",
  rewardsVouchers: "rewardvouchers",
  otpRetry: "emipod/otpretry",
  favCpInsert: "favcpinsert",
  favCpRead: "favcpread",
  getNearbyStores: "getnearbystores",
  offersDealer: "offersdealer",
  ruraldealeroffer: "ruraldealeroffer",
  getHashCode: "gethashcodebymobileno",
  offerSelection: "emipod/crosssell/offerselection",
  preapplication: "emipod/crosssell/preapplication",
  additionaldataprocess: "emipod/crosssell/additionaldataprocess",
  csCustomerPayment: "emipod/crosssell/cscustomerpayment",
  glInsert: "glinsert",
  goldRate: "goldrate",
  twfInsert: "twfinsert",
  solarInsert: "solarinsert",
  solarRead: "solarread",
  solarMaster: "solarmaster",
  consentRead: "consentread",
  balicRead: "balicread",
  profLoanInsert: "profloaninsert",
  ucfInsert: "ucfinsert",
  utlInsert: "utlinsert",
  channelFlag: "Brand",
  fdretrieve: "fdretrieve",
  tokenVerifySso: "token-verify-sso",
  mefInsert: "mefinsert",
  customerRelations: "custRelationshipDetails",
  blInsert: "psblinsert",
  crossSellB2C: "getb2caddonproduct",
  loanRewards: "getrmscampaigninfo",
  consentInsert: "consentinsert",
  custRelationship: "custRelationshipDetails",
  offers: "offers",
  loanDetails: "loanDetails",
  mmi: "mapMyIndia",
  qrCdInsert: "qrcdinsert",
  salplInsert: "salplinsert",
  plcsInsert: "plcsinsert",
  hlInsert: "hlinsert",
  cdInsert: "cdloaninsert",
  blseInsert: "blseinsert",
  cdRead: "cdloanread",
  readmyorder: "readmyorder",
  bestEMICard: "bestemicarddetails",
  lapInsert: "lapinsert",
  redBusCityMaster: "citymaster",
  recentSearches: "recentsearchmaster",
  cvInsert: "cvinsert",
  multiAssetApi: "offermartbre/multiassetapi",
};

export const MAX_RETRIES = 1;

export const API_RESPONSE_CODES = {
  STATUS_CODE_7001: "7001",
  STATUS_CODE_7002: "7002",
  STATUS_CODE_7003: "7003",
  STATUS_CODE_7004: "7004",
  STATUS_CODE_7005: "7005",
  STATUS_CODE_5005: 5005,
  STATUS_CODE_200: 200,
};

export const API_STATUS = {
  SUCCSS: "S",
  ERROR: "E",
};

export const QR_OFFER_TYPES = [
  "Vouchers",
  "Voucher",
  "BFL Vouchers",
  "OEM Vouchers",
  "Customer NPV1",
  "Customer NPV2",
  "Cashback",
  "NPV1",
  "NPV2",
  "BajajCoins",
  "Bajaj Coins",
  "Brand Vouchers",
];

export const B2C_DEFAULT_DOB = "1990-01-01";
export const PRODUCTS_APP_VERSION = "v2";
export const DEFAULT_OFFER_PRODUCT = "SPL";
export const DEFAULT_PROGRAM_NAME = "FULL UW";
export const DEFAULT_SEGMENT = "ALL";
export const DEFAULT_SOURCING_BRANCH_ID = "320";
export const DEFAULT_PROCESS_SEGMENTATION_C = "null";
export const DEFAULT_PROCESS_SEGMENTATION = "NEW";
export const DEFAULT_PROCESS_TYPE = "Full Underwriting";
export const DEFAULT_LOAN_TYPE = "New Loan";
export const DEFAULT_CURRENT_RESIDENCE_STATE = "ALL";

export const LOAN_TYPES_MAPPING: { [key: string]: string } = {
  term: "Normal Term Loan",
  flexi: "Dropline Flexi",
  hybrid: "Hybrid Flexi",
  "flexi-loan": "Dropline Flexi",
  emi_lite: "Term Loan Principal Holiday",
};

export const BFL_WHEELES_ERROR = "BFL_WHEELES_ERROR";
export const BRAND = "Brand";
export const RURAL = "rural";
export const V1 = "v1";
export const V3 = "v3";
export const V5 = "v5";

export const EVENT_CODE = {
  GOLD_LOAN: "GL_PDP",
  CD_LOAN: "PDP_DETAILS",
  QR_PDP_INSERT: "QR_PDP_INSERT",
  BLSE_SME_EVENT_CODE: "SME_BLSE",
};

export const V4 = "v4";
export const PSBL_PROD_NAME = "PSBL";
export const PSBL_EVENT_CODE_V4 = "SME_PSBL";
export const BLSE_PROD_NAME = "BLSE";
export const BLSE_SME_EVENT_CODE = "SME_BLSE";
export const SME_EVENT_NAME = "PDP_Details";
export const PDP_DETAILS = "PDP_Details";
export const PROF_EVENT = "SME_PRO";
export const PROF_PROD_NAME = "PRO";
export const CP_PL_STAMPING_UTM_SOURCE = "organic_bfl";
export const CP_PL_STAMPING_UTM_MEDIUM = "bfl";
export const APP_TYPE_PRIMARY = "Primary";
export const HYBRID = "hybrid";
export const SOURCE_ID = "3";
export const PLCS_LOAN_VARIANT = "Term Loan";
export const SAL_NO_OFFER = "SAL_NO_OFFER";
export const PLCS_GIN = "PLCS_GIN";
export const HL_INSERT_EVENT_CODE = "HL_PDP";

export const APP_TYPE = {
  PRIMARY: "Primary",
};

export const BLSE_CUST_TYPE = {
  INDIVIDUAL: "Individual",
};
